import { useEffect, useState } from 'react';
import { NB } from '@cerebral-inc/ui';
import { ADHD_SCORES } from './constants/score';

const { Box, Text, Square, useMediaQuery } = NB;

export interface SemiCircleProgressProps {
  score: number;
  severity: string;
  percentage: number;
}

const SemiCircleProgress = ({
  score,
  severity,
  percentage
}: SemiCircleProgressProps) => {
  const [rotation, setRotation] = useState(45);
  const [isSmMobile] = useMediaQuery({ minWidth: 0, maxWidth: 300 });
  const notIndicativeText = ADHD_SCORES[0].text;
  const indicativeText = ADHD_SCORES[1].text;

  useEffect(() => {
    const animateProgress = () => {
      let startRotation = 45;
      const endRotation = 45 + percentage * 1.8;
      const animate = () => {
        startRotation += (endRotation - startRotation) * 0.05;
        if (startRotation >= endRotation - 0.1) {
          startRotation = endRotation;
        }
        setRotation(startRotation);
        if (Math.round(startRotation) !== Math.round(endRotation)) {
          requestAnimationFrame(animate);
        }
      };
      animate();
    };
    animateProgress();
  }, [percentage]);

  return (
    <Box
      position="relative"
      textAlign="center"
      mt={{ base: '40px', md: 0 }}
      w={isSmMobile ? '140px' : { base: '200px', xl: '252px' }}
    >
      <Box
        position="relative"
        overflow="hidden"
        w={isSmMobile ? '140px' : { base: '200px', xl: '252px' }}
        h={isSmMobile ? '70px' : { base: '100px', xl: '126px' }}
        mb="-14px"
      >
        <Square
          position="absolute"
          top={0}
          left={0}
          w={isSmMobile ? '140px' : { base: '200px', xl: '252px' }}
          h={isSmMobile ? '140px' : { base: '200px', xl: '252px' }}
          borderRadius="50%"
          borderColor="#422E80"
          borderWidth="6px"
          borderBottomColor="#D9D5FF"
          borderRightColor="#D9D5FF"
          style={{ transform: `rotate(${rotation}deg)` } as object}
        />
      </Box>
      <Box mt={isSmMobile ? '-30px' : '-65px'}>
        <Text
          color="#FFFFFF"
          fontSize="32px"
          fontWeight={600}
          lineHeight="40px"
          textAlign="center"
          fontFamily="Poppins"
        >
          {score}
        </Text>
        <Text
          color="#FFFFFF"
          fontSize="12px"
          fontWeight={600}
          lineHeight="20px"
          textAlign="center"
          w="84%"
          ml="7%"
          fontFamily="Poppins"
        >
          {severity}
        </Text>
      </Box>
      <Box
        position="absolute"
        top="-70px"
        left="-30px"
        w={{ base: '90px', xl: '132px' }}
      >
        <Text
          color="#D9D5FF"
          fontSize="12px"
          lineHeight="16px"
          textAlign="right"
          fontFamily="Poppins"
        >
          0-3
        </Text>
        <Text
          color="#D9D5FF"
          fontSize="12px"
          lineHeight="16px"
          textAlign="right"
          fontFamily="Poppins"
        >
          {notIndicativeText}
        </Text>
      </Box>
      <Box
        left="50%"
        top="-70px"
        height="48px"
        position="absolute"
        borderLeftColor="#422E80"
        borderLeftStyle="dashed"
        borderLeftWidth="1px"
      />
      <Box
        position="absolute"
        top="-70px"
        right="-30px"
        w={{ base: '90px', xl: '132px' }}
      >
        <Text
          color="#D9D5FF"
          fontSize="12px"
          lineHeight="16px"
          textAlign="left"
          fontFamily="Poppins"
        >
          4-6
        </Text>
        <Text
          color="#D9D5FF"
          fontSize="12px"
          lineHeight="16px"
          textAlign="left"
          fontFamily="Poppins"
        >
          {indicativeText}
        </Text>
      </Box>
    </Box>
  );
};

export default SemiCircleProgress;
